import { GET } from "./_config";

export const getCompanyCountApi = async () =>
  await GET(`/super-admin/dashboard/companyCount`, true);
